import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PaymentIntent } from '@stripe/stripe-js';
import { Observable } from 'rxjs';
import { ResponseConfirmPayment } from '../../core/models/response-confirm-payment';
import { ResponseDefault } from '../../core/models/response-default';
import { environment } from '../../../environments/environment.development';
import { PaymentIntentEtoy } from '../../core/models/payment-intent';

@Injectable({
  providedIn: 'root',
})
export class StripeServiceAngular {
  constructor(private http: HttpClient) {}
  createPaymentIntent(intent: any) {
    return this.http.post<PaymentIntentEtoy>(`${environment.api}stripe/create-payment-intent`, intent);
  }
  updatePaymentIntent(update: any) {
    return this.http.post<PaymentIntentEtoy>(`${environment.api}stripe/update-payment-intent`, update);
  }
  postCheckout() {
    return this.http.post<ResponseDefault>(`${environment.api}/stripe/create-checkout-session`, {});
  }
  postCardStripe(body: any, id_firebase: string, id: string) {
    return this.http.post<any>(`${environment.api}stripe/add-card/${id_firebase}/${id}`, body);
  }
  postConfirmPayment(body: any) {
    return this.http.post<ResponseConfirmPayment>(`${environment.api}stripe/confirm-payment`, body);
  }
  postConfirmIntentPayment(body: any) {
    return this.http.post<ResponseConfirmPayment>(`${environment.api}stripe/confirm-intent-payment`, body);
  }
  postConfirmIntentPaymentCashback(body: any) {
    return this.http.post<ResponseConfirmPayment>(`${environment.api}stripe/confirm-intent-cashback`, body);
  }
  postChargeCreate(body: any) {
    return this.http.post<ResponseConfirmPayment>(`${environment.api}stripe/create-charge`, body);
  }
  updateToken() {}
  postSetupIntents(body: any) {
    return this.http.post<ResponseConfirmPayment>(`${environment.api}stripe/customer-create`, body);
  }
}
